import { blueGrey600, blueGrey900 } from 'material-ui/styles/colors';

export const style = {
  paper: {
    padding: '5px 5px 5px 5px',
    marginTop: '20px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '40px',
  },
  narrowInput: {
    width: '80px',
    marginLeft: '20px',
    padding: '5px 5px 5px 5px',
    margin: '3px 3px 3px 3px',
    border: '1px solid rgba(250,250,250,1)',
    borderBottom: '0px',
    WebkitBorderRadius: '5px 5px 5px 5px',
    MozBorderRadius: '5px 5px 5px 5px',
  },
  matterInput: {

    width: '125px',
    padding: '0px 5px 0px 0px',
    margin: '0px 3px 3px 0px',
    border: '1px solid rgba(250,250,250,1)',
    borderBottom: '0px',
    WebkitBorderRadius: '5px 5px 5px 5px',
    MozBorderRadius: '5px 5px 5px 5px',
  },
  input: {
    width: '105px',
    padding: '0px 5px 0px 0px',
    margin: '0px 3px 3px 0px',
    border: '1px solid rgba(250,250,250,1)',
    borderBottom: '0px',
    WebkitBorderRadius: '5px 5px 5px 5px',
    MozBorderRadius: '5px 5px 5px 5px',
  },

  longLabelText: {
    top: '30px',
  },
  inputInputStyle: {
    textAlign: 'right',
  },
  inputFloatingLabelStyle: {
    textAlign: 'left',
    color: blueGrey600,
  },
  inputFloatingLabelStyleForMatters: {
    textAlign: 'left',
    color: blueGrey600,
    top: '30px',
  },
  inputfloatingLabelFocusStyle: {
    color: blueGrey900,
  },

  inputUnderlineStyle: {
    borderColor: '#37474F',

  },
  form: {

  },
};



// WEBPACK FOOTER //
// ./src/containers/form/formStyle.js